module.exports = __webpack_public_path__ + "static/media/ready.9d2c5f50.png";